import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function audioReducer(state = initialState.audio, action) {
    switch(action.type){
        case types.SET_AUDIO_REF:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
            return Object.assign({},action.audio);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/audioReducer.js
 **/